import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
// import SuperTagHelper from "@/components/functionals/SuperTagHelperDashBoard.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import formatterTask from "@/components/functionals/formatterTask.vue";

export default [
  {
    prop: "ObjetiveID",
    label: "# Ob.",
    width: 80,
    sortable: true
  },
  {
    prop: "ObjetiveName",
    label: "Objetivo",
    width: 190,
    sortable: true
  },
  {
    prop: "ID",
    label: "# Tr.",
    width: 80,
    sortable: true
  },
  {
    prop: "Name",
    label: "Tarea",
    minWidth: 180,
    sortable: true
  },
  {
    prop: "Responsable",
    label: "Responsable",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "ResponsableTaskImage"
    }
  },
  {
    prop: "DiasRetrasados",
    label: "Dias Retrasada",
    align: "center",
    "min-width": 150,
    sortable: true,
    formatter: (row) => row.DiasRetrasados + " Días"
  },
  {
    prop: "InitialDate",
    label: "Fecha Inicio",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "LimitDate",
    label: "Fecha Compromiso",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "Duration",
    label: "Duracción",
    width: 110,
    sortable: true
  },
  {
    prop: "Status",
    label: "Estado",
    width: 200,
    sortable: true,
    formatter: formatterTask
  },
  {
    prop: "PerpectiveId",
    label: "Tipo Perspectiv",
    width: 200,
    sortable: true,
    formatter: formatterTask
  },
  {
    prop: "CreatorTask",
    label: "Creado",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "CreatorTaskImage"
    }
  },
  {
    prop: "SupervisorTask",
    label: "Supervisor",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "SupervisorTaskImage"
    }
  },
  {
    prop: "PercentageProsposal",
    label: "Progreso",
    width: 200,
    sortable: true,
    formatter: formatterTask
  },
  {
    prop: "TypeStrategic",
    label: "Tipo",
    width: 200,
    sortable: true,
    formatter: formatterTask
  },
  {
    prop: "ClosedDate",
    label: "Fecha Cierre",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  }
];
